export default {
	name: "resequence-delivery-orders-for-delivery",
	data() {
		return {
			vehicles: [],
			loading: false,
			deliveryResequence: {
				vehicleId:{
					value: null,
					hasError: false,
					errorMessage: null
				},
				expectedDateOfDelivery:{
					value: null,
					hasError: false,
					errorMessage: null
				},
			},
			deliveryBatches: [],
		};
	},
	methods: {
		getVehicles(){
			this.loading = true;
			let request = {
				isActive: true
			};
			systemService.getAllVehicles(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.vehicles = successResponse.data.result;
						this.vehicles = dataTableHelper.castFieldValues(this.vehicles);
						this.vehicles = $.map(this.vehicles,
							function (obj) {
								obj.id = obj.id || obj.vehicleId;
								obj.text = obj.text || obj.fleetNumber;
								return obj;
							});
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getDeliveryBatches() {
			if(this.deliveryResequence.vehicleId.value !== null && this.deliveryResequence.expectedDateOfDelivery.value !== null) {
				this.loading = true;
				let request = {
					vehicleId: this.deliveryResequence.vehicleId.value,
					expectedDateOfDelivery: this.deliveryResequence.expectedDateOfDelivery.value
				};

				orderService.getDeliveryOrdersByVehicleIdAndExpectedDeliveryDate(request).then(
					successResponse => {
						let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
						if(isSuccess) {
							this.deliveryBatches = successResponse.data.result;
							for(let i = 0; i < this.deliveryBatches.length; i++){
								this.deliveryBatches[i].errorMessage = null;
								this.deliveryBatches[i].hasError = false;
								let deliveryBatch = this.deliveryBatches[i];
								deliveryBatch.deliveryOrderAndSequences = dataTableHelper.castFieldValues(deliveryBatch.deliveryOrderAndSequences);
							}
						}
						this.loading = false;
					},
					errorResponse => {
						console.log("error", errorResponse);
						this.loading = false;
						apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
					}
				);
			}
		},
		onExpectedDateOfDeliverySelect(date){
			if(this.deliveryResequence.expectedDateOfDelivery.value !== date){
				this.deliveryResequence.expectedDateOfDelivery.value = date;
				this.getDeliveryBatches();
			}
		},
		onVehicleSelect(vehicle){
			if(this.deliveryResequence.vehicleId.value !== vehicle.id){
				this.deliveryResequence.vehicleId.value = vehicle.id;
				this.getDeliveryBatches();
			}
		},
		onSequenceInput(sequencedOrder, deliveryBatch) {
			console.log("on sequence", sequencedOrder)
			deliveryBatch.hasError = false;
			deliveryBatch.errorMessage = null;
			if(sequencedOrder.sequenceNo === null || sequencedOrder.sequenceNo === undefined || sequencedOrder.sequenceNo === ""){
				sequencedOrder.sequenceNo = 1;
			}
			if(sequencedOrder.sequenceNo < 1){
				sequencedOrder.sequenceNo = 1;
			}
			var withUniqueSequenceNumbers = [];
			var duplicateSequenceNumbers = deliveryBatch.deliveryOrderAndSequences.filter(o => {
				if(withUniqueSequenceNumbers.find(wo => wo.sequenceNo === o.sequenceNo)){
					return true;
				}
				withUniqueSequenceNumbers.push(o);
				return false;
			});
			if(duplicateSequenceNumbers.length > 0){
				deliveryBatch.hasError = true;
				deliveryBatch.errorMessage = "Sequence numbers duplicated for orders: " + duplicateSequenceNumbers.map(orderItem => orderItem.orderId).join(", ");
			}
			
			// var sequenceNumberExists = deliveryBatch.deliveryOrderAndSequences.some(order => order.sequenceNo === sequencedOrder.sequenceNo && order.orderId !== sequencedOrder.orderId);
			// if(sequenceNumberExists){
			// 	deliveryBatch.hasError = true;
			// 	deliveryBatch.errorMessage = "Sequence numbers duplicated for orders: " + deliveryBatch.deliveryOrderAndSequences.filter(order => order.sequenceNo === sequencedOrder.sequenceNo).map(order => order.orderId).join(", ");
			// }
			deliveryBatch.deliveryOrderAndSequences.sort((a, b) => a.sequenceNo - b.sequenceNo);
		},
		onResequenceOrdersButtonClick() {
			this.loading = true;
			var orderDeliverySequences = [];
			for(let i = 0; i < this.deliveryBatches.length; i++){
				let deliveryBatch = this.deliveryBatches[i];
				if(deliveryBatch.hasError){
					this.loading = false;
					return;
				}
				for(let j = 0; j < deliveryBatch.deliveryOrderAndSequences.length; j++){
					let order = deliveryBatch.deliveryOrderAndSequences[j];
					orderDeliverySequences.push({
						orderDeliveryId: order.orderDeliveryId,
						sequenceNumber: order.sequenceNo
					});
				}
			}
			let request = {
				orderDeliverySequences: orderDeliverySequences
			};
			orderService.updateSequenceNumberForOrderDeliveries(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.$router.go(-1);
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onBackClick(){
			this.$router.go(-1);
		},
		setBreadcrumbs() {
			var pageTitle = "Resequence Deliveries For Vehicle";
			storeState.setPageTitleAction(pageTitle);
			breadcrumbsStoreState.updateBreadcrumbs(this.$route, pageTitle);
		}
	},
	mounted: function () {
		this.setBreadcrumbs();
		this.getVehicles();
	}
};